import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  Box,
  Divider,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Stack,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TablePagination,
  Card
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import axios from "axios";
import { ReactComponent as DeleteIcon } from "../../../Icons/DeleteTable.svg";
import { ReactComponent as EditIcon } from "../../../Icons/EditIcon.svg";
import AlertModal from "../../../CommonComponents/AlertModal";
import LinearProgress from '@mui/material/LinearProgress';
import CachedIcon from '@mui/icons-material/Cached';
import VisibilityIcon from '@mui/icons-material/Visibility';
import dayjs from 'dayjs'
import {useDispatch} from 'react-redux'
import axiosInstance from '../../../api/axiosInstance'
import { removeData } from "../../../Redux/Feature/AdminSlice";
import PdfGenerate from "../../../PdfGenerate";
import DownloadIcon from '@mui/icons-material/Download';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export default function Services({setRenderBlock}) {
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [bookedService, setBookedService] = useState({})
  const [serviceData, setServiceData] = useState({})
  const [paymentData, setPaymentData] = useState({})

  const [invoiceData, setInvoiceData] = useState({
    header1 : 
      {
        line1 : 'Singapore Vinga',
        line2 : 'International Pte Ltd',
        line3 : 'https://singapore-v.com',
        line4 : 'vinga@gmail.com',
        line5 : '+65 6962 6868 / +65 6677 6789'
      },
    header2 : 
      {
        line1 : "Vinga Hall",
        line2 : 'No.99 Rangoon Road',
        line3 : 'Singapore 218384',
        line4 : 'UEN : 200516098N'
    },
    
  })

  const pdfRef = useRef(null);

  const handleGeneratePDF = () => {
    if (pdfRef.current) {
      pdfRef.current.generatePDFs();
    }
  };

  const formatNumber = (input) => {
    const phoneNumber = parsePhoneNumberFromString(input);
    if (phoneNumber) {
      return phoneNumber.formatInternational(); // or .formatNational()
    }
    return input; // fallback
  };



  let deleteData = {
    label: "Confirm Delete Service",
    descriptionOne: "Please confirm that you wish to delete the Service.",
    buttonOne: {
      variant: "outlined",
      color: "#0E5E84",
      backgroundColor: "#FFFFFF",
      text: "Cancel",
    },
    buttonTwo: {
      variant: "contained",
      color: "#FFFFFF",
      backgroundColor: "#912018",
      text: "Confirm",
    },
  };

  const [hostelData, setHostelData] = useState([]);
  const [selectedDescription, setSelectedDescription] = useState("");
  const [deleteModal, setDeleteModal] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const getAllHostel = async () => {
    setLoading(true)
    const id = localStorage.getItem("userId")
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}get-student-booked-service/${id}?page=${
            page + 1
          }&limit=${rowsPerPage}`
      );
      console.log(response);
      setHostelData(response?.data?.data || []);
      setTotalItems(response.data.pagination.totalItems || 0)
      setLoading(false)
    } catch (error) {
      console.log(error);
      setLoading(false)
      if(error.response.status === 401){
        navigate('/login')
        dispatch(removeData())
    }
    }
  };

  const handleClose = () => {
    setDeleteModal(null);
    setDeleteId(null);
  };

  const deleteHostel = async () => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}delete-booked-servic/${deleteId}`
      );
      getAllHostel();
      setDeleteModal(null);
      setDeleteId(null);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllHostel();
  }, [page, rowsPerPage]);


  const handleSeeMore = (description) => {
    setSelectedDescription(description);
  };


  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page change
  };

  const fetchPaymentData = async() => {
    try {
      const response = await axiosInstance.post(`get-payment-details-by-id`, {
        payment_id : serviceData?.form_data?.payment_id || serviceData?.form_data?.payment_details
      })
      if(response.status === 200){
        setPaymentData(response.data)
        if (pdfRef.current) {
          pdfRef.current.generatePDFs();
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  
  useEffect(() => {
      if(serviceData?.form_data?.payment_id || serviceData?.form_data?.payment_details){
        fetchPaymentData()
      }
  }, [serviceData])


  const downloadInvoice = async (invoiceData) => {
    const response = await fetch('http://localhost:5000/api/download-invoice', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(invoiceData),
    });
  
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
  
    const a = document.createElement('a');
    a.href = url;
    a.download = 'invoice.pdf';
    document.body.appendChild(a);
    a.click();
    a.remove();
  };
  
  // useEffect(() => {
  //     if(paymentData?.details?.payment?.paid === true){
  //       handleGeneratePDF()
  //     }
  // }, [paymentData])

  const FileDisplayCard = ({ bookedService, name, heading }) => {

    const images = bookedService?.form_data?.[name];
  
    if (!images || !Array.isArray(images)) return null;
  
    return images.map((file, index) => {
      const fileUrl = `/${file.path.replaceAll("\\", "/")}`;
      const isImage = file.mimetype?.startsWith("image");
  
      return (
        <Card key={index} sx={{ mt: 2, p: 2 }}>
          <Typography fontWeight="bold">{heading}</Typography>
  
          {isImage ? (
            <img
              src={`${process.env.REACT_APP_FILE_PATH}${file.filename}`}
              alt={file.originalname}
              style={{ maxWidth: "100%", marginTop: 8, borderRadius: 8 }}
            />
          ) : (
            <iframe
              src={`${process.env.REACT_APP_FILE_PATH}${file.filename}`}
              title={file.originalname}
              style={{ width: "100%", height: "300px", border: "1px solid #ccc", marginTop: 8 }}
            ></iframe>
          )}
        </Card>
      );
    });
  };

  

  return (
    <>
    <Box sx={{position : 'relative'}}>
      <Box sx={{position : 'absolute', top : '-2000000px'}}>
      <PdfGenerate 
      ref={pdfRef}
      data={invoiceData}  
      invoiceNumber={serviceData?._id}
      invoiceDate={serviceData?.createdAt}
      invoiceAmount={paymentData?.details?.payment?.amount}
      subject={serviceData?.service_name}
      />
      </Box>
      </Box>
      <Stack direction="row" justifyContent="space-between" sx={{position : 'relative'}}>
      
        <Typography variant="h7_1">Booked Services</Typography>

        <Box sx={{display : 'flex', gap : 3, alignItems : 'center'}}>
        <Typography variant="h7_1" sx={{cursor : 'pointer'}} title='Reload' onClick={() => getAllHostel()}><CachedIcon /></Typography>
        {/* <Button
          onClick={() => navigate("/Admin/add-common-service")}
          variant="contained"
        >
          Add
        </Button> */}
        </Box>
       
      </Stack>
      
      <TableContainer sx={{
        mt : 3.5,
          borderRadius: "5px",
          border: "1px solid #e5e5e5",
          boxShadow: "0px 0px 30px 20px #f4f4f4",
        }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Student Name
                </Typography>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                <Typography variant="h9_1" color="#333333">
                  Service Asked
                </Typography>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                <Typography variant="h9_1" color="#333333">
                 Order Complete Status
                </Typography>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Date and Time
                </Typography>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                {" "}
                <Typography variant="h9_1" color="#333333">
                  Actions
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {loading && (
              <TableRow>
                <TableCell colSpan={5} sx={{p :0, borderBottom : '0px'}}>
              <LinearProgress color="primary" />
              </TableCell>
              </TableRow>
            )}

            {hostelData.length == 0 ? (<>
              <TableRow>
              <TableCell colSpan={5} sx={{borderBottom: "0.5px solid #dcdddc", py: 2.7}}>
            {!loading && (
            <Typography>No data found</Typography>
            )}
            </TableCell>
            </TableRow>
            </>) : (
            hostelData.map((item, index) => (
              <TableRow
                key={item.name}
                sx={{border: "0px",
                backgroundColor: index % 2 === 0 ? "#f8f8f8" : "white"}}
              >
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}>
                <Typography variant="h9_4" color="#333333">
                    {item?.form_data?.name || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}>
                  <Typography variant="h9_4" color="#333333">
                    {item?.service_name || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc",  }}>
                    {item?.order_complete_status === true ? (
                      <>
                      <Box sx={{display : 'flex', justifyContent : 'center',alignItems : 'center', gap : 2}}>
                        <span style={{width : '20px', height : '20px', borderRadius : '100%', backgroundColor : '#4caf50'}}></span>
                        <Typography>Completed</Typography>
                      </Box>
                      </>
                    ) : (
                      <Box sx={{display : 'flex', justifyContent : 'center',alignItems : 'center', gap : 2}}>
                        <span style={{width : '20px', justifyContent : 'center',height : '20px', borderRadius : '100%', backgroundColor : '#ffac33'}}></span>
                        <Typography >Pending</Typography>
                      </Box>
                    )}
  
                </TableCell>
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}>
                  <Typography variant="h9_4" color="#333333">
                    {(item?.service_name === "English Trial Class" || item?.service_name === "Weekend Activities") ? dayjs(item?.createdAt).format("DD/MM/YYYY hh:mm A") : dayjs(item?.createdAt).format("DD/MM/YYYY hh:mm A")}
                  </Typography>
                </TableCell>
                <TableCell sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}>
                  <IconButton
                      disabled={item?.form_data?.payment_id == '0'}
                    onClick={() => {
                      // handleGeneratePDF()
                      setServiceData(item)
                    }}
                    sx={{ marginRight: "10px" }}
                  >
                    <DownloadIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                        setBookedService(item)
                        setOpen(true)
                        
                    }}
                    sx={{ marginRight: "10px" }}
                  >
                    <VisibilityIcon />
                  </IconButton>
                  {/* <IconButton
                    onClick={() => {
                      setDeleteId(item._id);
                      setDeleteModal(true);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            )))}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={totalItems} 
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />

      </TableContainer>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Service Details</DialogTitle>
        <Divider></Divider>
        <DialogContent>
        <Card sx={{mt : 2, p : 2}}>
            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Name</Typography>
                <Typography>{bookedService?.form_data?.name}</Typography>
            </Box>

            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Phone</Typography>
                <Typography>{formatNumber(`+${bookedService?.form_data?.phone}`)}</Typography>
            </Box>

            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Email</Typography>
                <Typography>{bookedService?.form_data?.email}</Typography>
            </Box>
        </Card>

        <Card sx={{mt : 2, p : 2}}>
            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Line</Typography>
                <Typography>{`${bookedService?.form_data?.line}`}</Typography>
            </Box>

            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>WeChat</Typography>
                <Typography>{`${bookedService?.form_data?.wechat}`}</Typography>
            </Box>

            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>WhatsApp</Typography>
                <Typography>{`${bookedService?.form_data?.whatsapp}`}</Typography>
            </Box>
        </Card>

            {bookedService?.form_data?.schoolAttended && (
                <Box sx={{mt : 2}}>
                    <Typography sx={{fontWeight : 700}}>School Attended</Typography>
                    <Typography>{`${bookedService?.form_data?.schoolAttended}`}</Typography>
                </Box>
            )}
            
            {bookedService?.form_data?.gradeYearOfStudy && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Grade Year of Study</Typography>
                <Typography>{bookedService?.form_data?.gradeYearOfStudy}</Typography>
            </Box>
            )}


            {bookedService?.form_data?.package && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Package</Typography>
                <Typography>{bookedService?.form_data?.package?.title}</Typography>
            </Box>
            )}

{bookedService?.form_data?.package && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Package Amount</Typography>
                <Typography>{bookedService?.form_data?.package?.amount}</Typography>
            </Box>
            )}

            {bookedService?.form_data?.startDate && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Start Date</Typography>
                <Typography>{dayjs(bookedService?.form_data?.startDate).format("DD/MM/YYYY hh:mm A")}</Typography>
            </Box>
            )}
            
            {bookedService?.form_data?.enlishTrialClassDate && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>English Trial Class Date</Typography>
                <Typography>{dayjs(bookedService?.form_data?.enlishTrialClassDate).format("DD/MM/YYYY")}</Typography>
            </Box>
            )}
            {bookedService?.form_data?.englishTrialClassTime && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>English Trial Class Time</Typography>
                <Typography>{bookedService?.form_data?.englishTrialClassTime}</Typography>
            </Box>
            )}

            {bookedService?.form_data?.flightno && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Flight No</Typography>
                <Typography>{bookedService?.form_data?.flightno}</Typography>
            </Box>
            )}

            {bookedService?.form_data?.luggageCount && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Luggage Count</Typography>
                <Typography>{bookedService?.form_data?.luggageCount}</Typography>
            </Box>
            )}

            {bookedService?.form_data?.pickUpLocation && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Pick Up Location</Typography>
                <Typography>{bookedService?.form_data?.pickUpLocation}</Typography>
            </Box>
            )}

            {bookedService?.form_data?.arrival_date && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Arrival Date</Typography>
                <Typography>{dayjs(bookedService?.form_data?.arrival_date).format("DD/MM/YYYY hh:mm A")}</Typography>
            </Box>
            )}
   

        {bookedService?.form_data?.img && (
            <FileDisplayCard bookedService={bookedService} name={'img'} heading={'Passport'}/>
        )}

        {bookedService?.form_data?.ipa && (
            <FileDisplayCard bookedService={bookedService} name={'ipa'} heading={'IPA'}/>
        )}

            {bookedService?.form_data?.passport && (
            <FileDisplayCard bookedService={bookedService} name={'passport'} heading={'Passport'}/>
        )}
        </DialogContent>
        <Divider></Divider>
        <DialogActions>
          <Button
            onClick={() => setOpen(false)}
            color="primary"
            variant="contained"
            sx={{ margin: "10px", padding: "10px 20px" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
